import dompurify from 'dompurify';

export const DisplayCards = (target, data) => {
	target.innerHTML = target.innerHTML + dompurify.sanitize(data);
}